import { render, staticRenderFns } from "./LayoutTemplate2.vue?vue&type=template&id=3065cc1e&"
import script from "@/scripts/LayoutTemplate/index.js?vue&type=script&lang=js&"
export * from "@/scripts/LayoutTemplate/index.js?vue&type=script&lang=js&"
import style0 from "./LayoutTemplate2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports